import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'CABnHAUL - Luxury Private Transportation Service',
  description = 'Experience premium luxury transportation with CABnHAUL. Professional private car service, executive transportation, and personalized luxury rides. Premium comfort and reliability. Call (215) 384-3448.',
  keywords = 'luxury transportation, private car service, executive transportation, premium taxi service, luxury rides, private driver, VIP transportation, luxury car service, executive car service, premium transportation, Philadelphia luxury transportation',
  image = 'https://cabnhaul.com/photo.png',
  url = 'https://cabnhaul.com',
  type = 'website',
  author = 'CABnHAUL'
}) => {
  const siteTitle = title.includes('CABnHAUL') ? title : `${title} | CABnHAUL`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="2104" />
      <meta property="og:image:height" content="1504" />
      <meta property="og:site_name" content="CABnHAUL" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
    </Helmet>
  );
};

export default SEO;

